import { useMemo } from 'react'
import { sortAlphabetically } from '../../../utils/Sort'
import { useAppSelector } from '../../utils/hooks'
import { selectCommonAgents, selectCustomAgents, selectProviderAgents } from '../../slices/agents/agentsSlice'

export default function useCampaignTypes() {
	const commonAgents = useAppSelector(selectCommonAgents)
	const providerAgents = useAppSelector(selectProviderAgents)
	const customAgents = useAppSelector(selectCustomAgents)

	const campaignTypes = useMemo(() => {
		const types = sortAlphabetically([...commonAgents, ...providerAgents])
		return [...types, ...sortAlphabetically(customAgents)]
	}, [commonAgents, providerAgents, customAgents])

	return {
		campaignTypes,
	}
}
